import {Value} from "./Value";
import {IntervalMode, IntervalEnumLabels} from "./Interval";

type ValueFactoryType = (value: any) => Value;

export enum ActionTypeEnum {
    ALL_TIME = 'all-time',
    TODAY = 'day',
    YESTERDAY = 'yesterday',
    EXACT_DATE = 'exact-date',
    MANUAL_PERIOD = 'manual-period',
    WEEK = 'week',
    MONTH = 'month',
    YEAR = 'year',
}

export class Action {
    type: ActionTypeEnum;
    title: string;
    valueFactory: ValueFactoryType

    constructor(type: ActionTypeEnum, title: string, valueFactory: ValueFactoryType) {
        this.type = type;
        this.title = title;
        this.valueFactory = valueFactory;
    }

    static createByInterval(type: ActionTypeEnum, mode: IntervalMode): Action {
        return new Action(type, IntervalEnumLabels(mode), () => {
            return Value.createByInterval(mode);
        })
    }
}
